import Box, { Flex } from '@spotnana/pixel-react/dist/Box';
import cssWrapper from '@spotnana/pixel-react/dist/utils/cssWrapper';
import Rating from '@spotnana/pixel-react/dist/Rating';
import theme from '@spotnana/pixel-react/dist/utils/themes/theme';
import styled from 'styled-components';
import { css } from '@emotion/react';
import { cssSelectors, margins } from '@spotnana/blocks/src/utils';

export const Container = styled(Box)(
  cssWrapper({
    minWidth: '100%',
  }),
);

export const PolicyInfoRow = styled(Flex)(
  cssWrapper({
    alignItems: 'center',
    justifyContent: 'space-between',
  }),
);

export const HeaderTitle = styled(Box)(
  cssWrapper({
    fontWeight: 'semiBold',
    fontSize: 'small',
    lineHeight: 'label',
    textTransform: 'uppercase',
    color: 'text.label',
  }),
);

export const Divider = styled(Box)(
  cssWrapper({
    width: '100%',
    height: '1px',
    backgroundColor: 'bg.lightBlueGrey',
  }),
);

export const Predicate = styled(Flex)(
  cssWrapper({
    fontSize: 'small',
    lineHeight: 'switchLabel',
    fontWeight: 'regular',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginRight: '20px',
  }),
);

export const PredicateLabel = styled.span(
  cssWrapper({
    marginRight: '4px',
    color: theme.colors.text.label,
  }),
);

export const ExpectedValue = styled.span(
  cssWrapper({
    fontWeight: 'semiBold',
    color: theme.colors.text.label,
  }),
);

export const ActualValue = styled.span(
  cssWrapper({
    fontSize: 'small',
    lineHeight: 'switchLabel',
    fontWeight: 'semiBold',
    color: theme.colors.error,
    whiteSpace: 'nowrap',
  }),
);

export const ActualRating = styled(Rating)(
  cssWrapper({
    '.MuiRating-icon': {
      color: theme.colors.error,
      fontSize: '1.2rem',
    },
    '.MuiRating-iconEmpty': {
      color: theme.colors.error,
      opacity: 0.2,
    },
  }),
);

export const ExpectedRating = styled(Rating)(
  cssWrapper({
    marginLeft: '8px',
    '.MuiRating-icon': {
      fontSize: '1.2rem',
    },
    '.MuiRating-iconEmpty': {
      color: 'text.gold',
      opacity: 0.2,
    },
    color: theme.colors.text.label,
  }),
);

export const PolicyInfoLabel = styled(Box)(
  cssWrapper({
    flexGrow: 1,
    marginRight: '16px',
    minWidth: '140px',
  }),
);

export const PolicyInfoValue = styled(Flex)(
  cssWrapper({
    flexShrink: 0,
    width: '110px',
    justifyContent: 'flex-end',
  }),
);

export const ContentWrapper = styled(Box)(
  cssWrapper({
    padding: '0 20px',
    borderRadius: 'sm',
    border: `1px solid ${theme.colors.errorBorder}`,
  }),
);

export const RulesList = styled.ul(
  cssWrapper({
    font: 'inherit',
    lineHeight: 'switchLabel',
    fontSize: 'small',
    fontWeight: 'regular',
    listStyleType: 'disc',
    padding: '15px 0 15px 15px',
  }),
);

export const ContentHeader = styled.div(
  cssWrapper({
    margin: '0 0 20px',
    fontWeight: 'semiBold',
    fontSize: 'h4',
    lineHeight: 'switchLabel',
    color: theme.colors.error,
  }),
);

export const SubViolationInfo = styled.p(
  cssWrapper({
    fontWeight: 'regular',
    fontSize: 'small',
    lineHeight: '20px',
    color: theme.colors.text.label,
  }),
);

export const restriction_item = css`
  ${margins.yt.m2}

  &${cssSelectors.firstOfType} {
    ${margins.yt.m0}
  }
`;
